exports.list = {
    path: '/rekomendasi',
    name: 'rekomendasi_list', 
      meta: {
        authRequired: true,
      },
    component: () => import("@/views/main/rekomendasi/List.vue"),
}
exports.show = {
    path: '/rekomendasi/show/:id',
    name: 'rekomendasi_show', 
        meta: {
            authRequired: true,
        },
    component: () => import("@/views/main/rekomendasi/Show.vue"),
}